module.exports = __webpack_public_path__ + "static/media/v-line-safes.62515e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/v-line-safes.png
// module id = 1296
// module chunks = 0